// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from '../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  text: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontFamily: 'Poppins',
    fontSize: 13,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginTop: '20px',
  },
}))
